// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileVerifiedView-space1-V_qmH {
	margin-bottom: 6px !important;
}

.ProfileVerifiedView-space2-lVBOX {
	margin-bottom: 12px !important;
}

.ProfileVerifiedView-space3-GKIqW {
	margin-bottom: 18px !important;
}

.ProfileVerifiedView-space4-pNwPK {
	margin-bottom: 24px !important;
}

.ProfileVerifiedView-space5-PI9VB {
	margin-bottom: 30px !important;
}

.ProfileVerifiedView-space6-QIuvY {
	margin-bottom: 36px !important;
}

.ProfileVerifiedView-space7-V7JX4 {
	margin-bottom: 42px !important;
}

.ProfileVerifiedView-space8-IaOxv {
	margin-bottom: 48px !important;
}

.ProfileVerifiedView-spaceTop1-t4p5w {
	margin-top: 6px !important;
}

.ProfileVerifiedView-spaceTop2-rvccE {
	margin-top: 12px !important;
}

.ProfileVerifiedView-spaceTop3-bjGih {
	margin-top: 18px !important;
}

.ProfileVerifiedView-spaceTop4-cWSby {
	margin-top: 24px !important;
}

.ProfileVerifiedView-spaceTop5-oQvdE {
	margin-top: 30px !important;
}

.ProfileVerifiedView-spaceTop6-kiJzE {
	margin-top: 36px !important;
}

.ProfileVerifiedView-spaceTop7-eiwuI {
	margin-top: 42px !important;
}

.ProfileVerifiedView-spaceTop8-bKlkt {
	margin-top: 48px !important;
}

.ProfileVerifiedView-noMargin-WPytt {
	margin: 0px !important;
}

.ProfileVerifiedView-padding1-Ef84S {
	padding-bottom: 6px !important;
}

.ProfileVerifiedView-padding2-R4_IE {
	padding-bottom: 12px !important;
}

.ProfileVerifiedView-padding3-QgAIC {
	padding-bottom: 18px !important;
}

.ProfileVerifiedView-padding4-KGs5J {
	padding-bottom: 24px !important;
}

.ProfileVerifiedView-padding5-Go8p5 {
	padding-bottom: 30px !important;
}

.ProfileVerifiedView-padding6-yKOk4 {
	padding-bottom: 36px !important;
}

.ProfileVerifiedView-padding7-w6FZY {
	padding-bottom: 42px !important;
}

.ProfileVerifiedView-paddingTop1-fxvEa {
	padding-top: 6px !important;
}

.ProfileVerifiedView-paddingTop2-ffg35 {
	padding-top: 12px !important;
}

.ProfileVerifiedView-paddingTop3-OW0w6 {
	padding-top: 18px !important;
}

.ProfileVerifiedView-paddingTop4-mW2s1 {
	padding-top: 24px !important;
}

.ProfileVerifiedView-paddingTop5-yATOO {
	padding-top: 30px !important;
}

.ProfileVerifiedView-paddingTop6-T0GB_ {
	padding-top: 36px !important;
}

.ProfileVerifiedView-paddingTop7-dhQ_i {
	padding-top: 42px !important;
}

.ProfileVerifiedView-noPadding-SoCu6 {
	padding: 0px !important;
}

.ProfileVerifiedView-spaceMarginBottom0-yxVtF {
	margin-bottom: 0;
}

.ProfileVerifiedView-textBold-x2cl7 {
	font-weight: 500 !important;
}

.ProfileVerifiedView-textBolder-X0uK1 {
	font-weight: 700 !important;
}

.ProfileVerifiedView-textNormal-yOrEt {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ProfileVerifiedView-textDarkBlue-EnE6U {
	color: rgb(20, 39, 94) !important;
}

.ProfileVerifiedView-textLightBlue-Tb4KC {
	color: rgb(57, 87, 106) !important;
}

.ProfileVerifiedView-textLightSandleGreen-PZkDh {
	color: rgb(76, 86, 41) !important;
}

.ProfileVerifiedView-textLightBrown-HWKs8 {
	color: rgb(115, 79, 33) !important;
}

.ProfileVerifiedView-textMediumMaroon-wPGip {
	color: rgb(87, 37, 51) !important;
}

.ProfileVerifiedView-textBrown-ZThmR {
	color: rgb(160, 47, 24) !important;
}

.ProfileVerifiedView-textMaroon-X55jh {
	color: rgb(155, 49, 67) !important;
}

.ProfileVerifiedView-textDarkBrown-xaQ5M {
	color: rgb(83, 18, 16) !important;
}

.ProfileVerifiedView-textMediumBrown-y1V8v {
	color: rgb(142, 28, 10) !important;
}

.ProfileVerifiedView-textSkyBlue-fCBqw {
	color: rgb(37, 117, 141) !important;
}

.ProfileVerifiedView-textGray-nz2Mj {
	color: rgb(77, 65, 51) !important;
}

.ProfileVerifiedView-errorMessage-OrRC1 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ProfileVerifiedView-userText-MVryC {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ProfileVerifiedView-panelHeader-JadQ5 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ProfileVerifiedView-exportSection-QhXyn {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ProfileVerifiedView-exportSectionGridSub-fvRph {
	grid-template-columns: 50% 49% !important;
}

.ProfileVerifiedView-exportText-i_8W0 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ProfileVerifiedView-exportLinkImg-q6D9S {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ProfileVerifiedView-exportImg-Ewngr {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ProfileVerifiedView-linkBtn-gzCjo {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ProfileVerifiedView-table-T5jsR {
	display: table;
}

.ProfileVerifiedView-tableRow-CBrLs {
	display: table-row;
}

.ProfileVerifiedView-tableCell-uoW_G {
	display: table-cell;
	float: none;
}

.ProfileVerifiedView-formGroup-hzwdH {
	margin-bottom: 6px;
}

.ProfileVerifiedView-marginTop0-YHOlJ {
	margin-top: 0;
}

.ProfileVerifiedView-marginBottom20-E6aCZ {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ProfileVerifiedView-bannerImageBg-n4wLG {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ProfileVerifiedView-bannerDelete-zhHGk {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ProfileVerifiedView-exportLink-F6c53 {
	padding-top: 10px;
	padding-right: 10px;
}

.ProfileVerifiedView-seachContent-M8ijY {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ProfileVerifiedView-marginBottom9-ui3xn {
	margin-bottom: 9px;
}

.ProfileVerifiedView-spaceTop52-q7Z3Y {
	margin-top: 52px;
}

.ProfileVerifiedView-profileViewInner-Y193J {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ProfileVerifiedView-profileViewMain-x_nmo {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ProfileVerifiedView-profileViewlabel-EqsUd {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ProfileVerifiedView-profileViewMainContent-C1NN5 {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ProfileVerifiedView-reviewsFormStar-H2KHo {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ProfileVerifiedView-reviewsFormStar-H2KHo svg {
	cursor: pointer;
}

.ProfileVerifiedView-addLanguageText-wyoKq {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ProfileVerifiedView-exportSection-QhXyn {
		grid-template-columns: 100%;
	}

	.ProfileVerifiedView-spaceTop52-q7Z3Y {
		margin-top: 18px;
	}

	.ProfileVerifiedView-exportText-i_8W0 {
		float: none;
		margin-top: 12px;
	}

	.ProfileVerifiedView-exportSectionGridSub-fvRph {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ProfileVerifiedView-profileViewlabel-EqsUd {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ProfileVerifiedView-profileViewMainContent-C1NN5 {
		width: 100%;
		text-align: center;
	}

	.ProfileVerifiedView-panelHeader-JadQ5 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.ProfileVerifiedView-profileHeader-ENIGF {
    background-color: var(--common-gray-bg-color);
    padding: 14px 24px;
    border-radius: 4px 4px 0 0;
}

.ProfileVerifiedView-profileAvatar-Dtdy0 {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: transparent;
    -o-object-fit: cover;
       object-fit: cover;
    margin-right: 25px;
}

.ProfileVerifiedView-dataListItem-LdSok {
    padding: 16px 24px;
    border-top: 1px solid var(--primary-border);
}

.ProfileVerifiedView-profileViewGrid-RijJV {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 20px;
}

.ProfileVerifiedView-noProfilePadding-WW8MB {
    padding: 0;
}

@media screen and (max-width:767px) {
    .ProfileVerifiedView-profileViewGrid-RijJV {
        grid-template-columns: 1fr;
        gap: 15px;
    }

    .ProfileVerifiedView-profileAvatar-Dtdy0 {
        margin-right: 0;
        margin-bottom: 15px;
    }

    .ProfileVerifiedView-gobackMobileSpace-cE4EV {
        margin-top: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/ProfileVerifiedView/ProfileVerifiedView.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,6CAA6C;IAC7C,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAiB;OAAjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.profileHeader {\n    background-color: var(--common-gray-bg-color);\n    padding: 14px 24px;\n    border-radius: 4px 4px 0 0;\n}\n\n.profileAvatar {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-color: transparent;\n    object-fit: cover;\n    margin-right: 25px;\n}\n\n.dataListItem {\n    padding: 16px 24px;\n    border-top: 1px solid var(--primary-border);\n}\n\n.profileViewGrid {\n    display: grid;\n    grid-template-columns: 1fr 2fr;\n    gap: 20px;\n}\n\n.noProfilePadding {\n    padding: 0;\n}\n\n@media screen and (max-width:767px) {\n    .profileViewGrid {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n\n    .profileAvatar {\n        margin-right: 0;\n        margin-bottom: 15px;\n    }\n\n    .gobackMobileSpace {\n        margin-top: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ProfileVerifiedView-space1-V_qmH`,
	"space2": `ProfileVerifiedView-space2-lVBOX`,
	"space3": `ProfileVerifiedView-space3-GKIqW`,
	"space4": `ProfileVerifiedView-space4-pNwPK`,
	"space5": `ProfileVerifiedView-space5-PI9VB`,
	"space6": `ProfileVerifiedView-space6-QIuvY`,
	"space7": `ProfileVerifiedView-space7-V7JX4`,
	"space8": `ProfileVerifiedView-space8-IaOxv`,
	"spaceTop1": `ProfileVerifiedView-spaceTop1-t4p5w`,
	"spaceTop2": `ProfileVerifiedView-spaceTop2-rvccE`,
	"spaceTop3": `ProfileVerifiedView-spaceTop3-bjGih`,
	"spaceTop4": `ProfileVerifiedView-spaceTop4-cWSby`,
	"spaceTop5": `ProfileVerifiedView-spaceTop5-oQvdE`,
	"spaceTop6": `ProfileVerifiedView-spaceTop6-kiJzE`,
	"spaceTop7": `ProfileVerifiedView-spaceTop7-eiwuI`,
	"spaceTop8": `ProfileVerifiedView-spaceTop8-bKlkt`,
	"noMargin": `ProfileVerifiedView-noMargin-WPytt`,
	"padding1": `ProfileVerifiedView-padding1-Ef84S`,
	"padding2": `ProfileVerifiedView-padding2-R4_IE`,
	"padding3": `ProfileVerifiedView-padding3-QgAIC`,
	"padding4": `ProfileVerifiedView-padding4-KGs5J`,
	"padding5": `ProfileVerifiedView-padding5-Go8p5`,
	"padding6": `ProfileVerifiedView-padding6-yKOk4`,
	"padding7": `ProfileVerifiedView-padding7-w6FZY`,
	"paddingTop1": `ProfileVerifiedView-paddingTop1-fxvEa`,
	"paddingTop2": `ProfileVerifiedView-paddingTop2-ffg35`,
	"paddingTop3": `ProfileVerifiedView-paddingTop3-OW0w6`,
	"paddingTop4": `ProfileVerifiedView-paddingTop4-mW2s1`,
	"paddingTop5": `ProfileVerifiedView-paddingTop5-yATOO`,
	"paddingTop6": `ProfileVerifiedView-paddingTop6-T0GB_`,
	"paddingTop7": `ProfileVerifiedView-paddingTop7-dhQ_i`,
	"noPadding": `ProfileVerifiedView-noPadding-SoCu6`,
	"spaceMarginBottom0": `ProfileVerifiedView-spaceMarginBottom0-yxVtF`,
	"textBold": `ProfileVerifiedView-textBold-x2cl7`,
	"textBolder": `ProfileVerifiedView-textBolder-X0uK1`,
	"textNormal": `ProfileVerifiedView-textNormal-yOrEt`,
	"textDarkBlue": `ProfileVerifiedView-textDarkBlue-EnE6U`,
	"textLightBlue": `ProfileVerifiedView-textLightBlue-Tb4KC`,
	"textLightSandleGreen": `ProfileVerifiedView-textLightSandleGreen-PZkDh`,
	"textLightBrown": `ProfileVerifiedView-textLightBrown-HWKs8`,
	"textMediumMaroon": `ProfileVerifiedView-textMediumMaroon-wPGip`,
	"textBrown": `ProfileVerifiedView-textBrown-ZThmR`,
	"textMaroon": `ProfileVerifiedView-textMaroon-X55jh`,
	"textDarkBrown": `ProfileVerifiedView-textDarkBrown-xaQ5M`,
	"textMediumBrown": `ProfileVerifiedView-textMediumBrown-y1V8v`,
	"textSkyBlue": `ProfileVerifiedView-textSkyBlue-fCBqw`,
	"textGray": `ProfileVerifiedView-textGray-nz2Mj`,
	"errorMessage": `ProfileVerifiedView-errorMessage-OrRC1`,
	"userText": `ProfileVerifiedView-userText-MVryC`,
	"panelHeader": `ProfileVerifiedView-panelHeader-JadQ5`,
	"exportSection": `ProfileVerifiedView-exportSection-QhXyn`,
	"exportSectionGridSub": `ProfileVerifiedView-exportSectionGridSub-fvRph`,
	"exportText": `ProfileVerifiedView-exportText-i_8W0`,
	"exportLinkImg": `ProfileVerifiedView-exportLinkImg-q6D9S`,
	"exportImg": `ProfileVerifiedView-exportImg-Ewngr`,
	"linkBtn": `ProfileVerifiedView-linkBtn-gzCjo`,
	"table": `ProfileVerifiedView-table-T5jsR`,
	"tableRow": `ProfileVerifiedView-tableRow-CBrLs`,
	"tableCell": `ProfileVerifiedView-tableCell-uoW_G`,
	"formGroup": `ProfileVerifiedView-formGroup-hzwdH`,
	"marginTop0": `ProfileVerifiedView-marginTop0-YHOlJ`,
	"marginBottom20": `ProfileVerifiedView-marginBottom20-E6aCZ`,
	"bannerImageBg": `ProfileVerifiedView-bannerImageBg-n4wLG`,
	"bannerDelete": `ProfileVerifiedView-bannerDelete-zhHGk`,
	"exportLink": `ProfileVerifiedView-exportLink-F6c53`,
	"seachContent": `ProfileVerifiedView-seachContent-M8ijY`,
	"marginBottom9": `ProfileVerifiedView-marginBottom9-ui3xn`,
	"spaceTop52": `ProfileVerifiedView-spaceTop52-q7Z3Y`,
	"profileViewInner": `ProfileVerifiedView-profileViewInner-Y193J`,
	"profileViewMain": `ProfileVerifiedView-profileViewMain-x_nmo`,
	"profileViewlabel": `ProfileVerifiedView-profileViewlabel-EqsUd`,
	"profileViewMainContent": `ProfileVerifiedView-profileViewMainContent-C1NN5`,
	"reviewsFormStar": `ProfileVerifiedView-reviewsFormStar-H2KHo`,
	"addLanguageText": `ProfileVerifiedView-addLanguageText-wyoKq`,
	"profileHeader": `ProfileVerifiedView-profileHeader-ENIGF`,
	"profileAvatar": `ProfileVerifiedView-profileAvatar-Dtdy0`,
	"dataListItem": `ProfileVerifiedView-dataListItem-LdSok`,
	"profileViewGrid": `ProfileVerifiedView-profileViewGrid-RijJV`,
	"noProfilePadding": `ProfileVerifiedView-noProfilePadding-WW8MB`,
	"gobackMobileSpace": `ProfileVerifiedView-gobackMobileSpace-cE4EV`
};
module.exports = ___CSS_LOADER_EXPORT___;
